module.exports = __webpack_public_path__ + "static/img/operations_search.87c6fcb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/operations_search.svg
// module id = zP+X
// module chunks = 1